import React from 'react';

/**
 * Utilitário para formatar erros de API
 * Converte objetos de erro em strings legíveis
 */

/**
 * Extrai mensagem de erro de uma resposta de API
 * @param {Object} error - Objeto de erro do axios
 * @returns {string} - Mensagem de erro formatada
 */
export const formatarErroAPI = (error) => {
  console.error('Erro capturado:', error.response?.data);
  
  // Se não houver resposta, erro de rede
  if (!error.response) {
    return 'Erro de conexão com o servidor';
  }
  
  const detail = error.response?.data?.detail;
  
  // Se não há detail, erro genérico
  if (!detail) {
    return error.response?.data?.message || 'Erro ao processar requisição';
  }
  
  // Se detail é array (erros de validação FastAPI/Pydantic)
  if (Array.isArray(detail)) {
    return detail
      .map(erro => {
        const campo = erro.loc?.[1] || erro.loc?.[0] || 'Campo';
        const mensagem = erro.msg || 'inválido';
        return `${campo}: ${mensagem}`;
      })
      .join('; ');
  }
  
  // Se detail é string, retornar diretamente
  if (typeof detail === 'string') {
    return detail;
  }
  
  // Se detail é objeto, tentar converter para mensagem legível
  if (typeof detail === 'object') {
    // Tentar extrair mensagem comum
    if (detail.message) return detail.message;
    if (detail.msg) return detail.msg;
    if (detail.error) return detail.error;
    
    // Fallback: stringificar objeto
    return JSON.stringify(detail);
  }
  
  // Fallback final
  return 'Erro desconhecido';
};

/**
 * Hook personalizado para gerenciar estado de erro
 * @returns {Object} - { error, setError, mostrarErro }
 */
export const useErroAPI = () => {
  const [error, setError] = React.useState('');
  
  const mostrarErro = (err) => {
    const mensagem = formatarErroAPI(err);
    setError(mensagem);
  };
  
  return { error, setError, mostrarErro };
};

export default formatarErroAPI;
